<sui-dialog
  role="alertdialog"
  aria-modal="true"
  tabindex="0"
  [attr.aria-label]="data.title | translate"
  [title]="data.title | translate"
  [dismissible]="true"
  [cdkTrapFocus]="true"
  [cdkTrapFocusAutoCapture]="true"
  (closed)="dismiss()"
>
  <p>{{ data.text | translate: data.textParams }}</p>

  <ng-template #dialogFooter>
    <sui-button
      variant="outline"
      radius="small"
      size="lg"
      (click)="dismiss()"
      >{{ 'global.cancel' | translate }}</sui-button
    >
    <sui-button
      radius="small"
      size="lg"
      [color]="data.destructive ? 'destructive' : 'brand'"
      [iconStart]="data.destructive ? 'trash' : undefined"
      (click)="confirm()"
      >{{ data.confirmLabel ?? 'global.confirm' | translate }}</sui-button
    >
  </ng-template>
</sui-dialog>
